
import { PodDexController } from "@/app/ui/controllers/PodDexController";
import { UpdatePodDexApiRequest } from "@/data/payload/api/PodDexRequest";
import { ShipmentBookingDetail } from "@/domain/entities/ShipmentBooking";
import { Options, prop, Vue } from "vue-class-component";
import UploadFile from "@/app/ui/components/upload-file/index.vue";
import { MainAppController } from "@/app/ui/controllers/MainAppController";
import {
  ModalMessageEntities,
  UploadMultiple
} from "@/domain/entities/MainApp";
import { UrgentDeliveryManagementController } from "@/app/ui/controllers/UrgentDeliveryManagementController";
import {
  DeleteHydraFileRequest,
  UploadHydraFileRequest
} from "@/data/payload/api/BookingRequest";
import { BookingController } from "@/app/ui/controllers/BookingController";
import { parsingErrorResponse } from "@/app/infrastructures/misc/Utils";

class Props {
  data = prop<ShipmentBookingDetail>({
    default: new ShipmentBookingDetail({}),
    type: ShipmentBookingDetail
  });
}
@Options({
  components: {
    UploadFile
  }
})
export default class SectionUploadPOD extends Vue.with(Props) {
  mounted() {
    this.onResetForm();
    PodDexController.getListPODRecipientRelation();
  }

  isOpenSelectRelation = false;
  onOpenSelectRelation() {
    this.isOpenSelectRelation = true;
  }

  onCloseSelectRelation() {
    this.isOpenSelectRelation = false;
  }

  onSelectRelation(name: string, value: string) {
    this.onCloseSelectRelation();
    this.form.relationId = value;
    this.form.relation = name;
  }

  get listRecipientRelation() {
    return [
      { name: "Pilih relasi", value: "" },
      ...PodDexController.listRecipientRelation.data
    ];
  }

  get maxPhoto() {
    return 4;
  }

  proofPhotos: any = [];

  onResetForm() {
    this.isClearFile = true;
    this.form = {
      sentValue: "",
      receiverName: "",
      files: [],
      relation: "",
      relationId: ""
    };
    this.proofPhotos.length = 1;
    this.form.files = new Array(this.maxPhoto).fill("");
  }

  get isDisableConfirm(): boolean {
    return (
      !this.form.receiverName ||
      !this.form.relation ||
      !this.form.relationId ||
      this.isEmptyPhoto
    );
  }

  get isEmptyPhoto() {
    return !this.form.files.some((key: any) => key);
  }

  isClearFile = false;
  form = {
    sentValue: "",
    receiverName: "",
    files: [] as any,
    relation: "",
    relationId: ""
  };

  showSuccessPopup() {
    MainAppController.showMessageModal(
      new ModalMessageEntities({
        image: "badge-success",
        title: this.$t("urgentDeliveryManagement.upload.successTitle"),
        message: this.$t("urgentDeliveryManagement.upload.successMessage"),
        textSuccess: this.$t("urgentDeliveryManagement.upload.buttonOk"),
        onSubmit: () => {
          MainAppController.closeMessageModal();
          UrgentDeliveryManagementController.setSttInfo({
            sttId: 0,
            sttNo: ""
          });
          this.$router.push("/urgent-delivery-management/taken-by-recipient/");
        }
      })
    );
  }

  showConfirmation() {
    MainAppController.showMessageModal(
      new ModalMessageEntities({
        image: "badge-confirmation-general",
        title: this.$t("urgentDeliveryManagement.upload.confirmationTitle"),
        message: this.$t("urgentDeliveryManagement.upload.confirmationMessage"),
        textCancel: this.$t("urgentDeliveryManagement.upload.buttonCheckAgain"),
        textSuccess: this.$t("urgentDeliveryManagement.upload.buttonYesUpdate"),
        onClose: () => {
          MainAppController.closeMessageModal();
        },
        onSubmit: () => {
          MainAppController.closeMessageModal();
          this.onUpdate();
        }
      })
    );
  }

  async onUpdate() {
    const isSuccess = await PodDexController.updatePodDex(
      new UpdatePodDexApiRequest({
        attachments: this.form.files.filter((key: any) => key !== ""),
        sttNo: this.data.sttNo,
        isDelivered: true,
        receiverName: this.form.receiverName,
        notDeliveredReason: "",
        remarks: "",
        isCustomTitle: "Update POD Gagal !",
        recipientRelation: this.form.relation,
        recipientRelationId: this.form.relationId
      })
    );
    if (isSuccess) this.showSuccessPopup();
  }

  async onUpload(params: UploadMultiple) {
    MainAppController.closeMessageModal();
    MainAppController.closeErrorMessage();
    MainAppController.showLoading();
    try {
      if (params.file) {
        const fileLink = await BookingController.uploadHydraFile(
          new UploadHydraFileRequest({
            attachFile: params.file,
            folderPath: "pod-from-taken-by-recipient/"
          })
        );
        this.form.files[params.index] = fileLink.data;
        if (this.proofPhotos.length < this.maxPhoto)
          this.proofPhotos.push(null);
      }
    } catch (err) {
      MainAppController.showErrorMessage(
        parsingErrorResponse(err, this.$t("bookingShipment.error.uploadPhoto"))
      );
    } finally {
      MainAppController.closeLoading();
    }
  }

  async onRemove(index: number) {
    MainAppController.closeMessageModal();
    MainAppController.closeErrorMessage();
    MainAppController.showLoading();
    try {
      const del = await BookingController.deleteHydraFile(
        new DeleteHydraFileRequest({
          attachFiles: [this.form.files[index]]
        })
      );
      const statusDel = del.data[this.form.files[index]];
      if (statusDel) {
        this.form.files[index] = "";
      }
    } catch (err) {
      MainAppController.showErrorMessage(
        parsingErrorResponse(
          err,
          this.$t("urgentDeliveryManagement.upload.errorDeletePhoto")
        )
      );
    } finally {
      MainAppController.closeLoading();
    }
  }
}
